import { request } from "@/utils/request"

export function getFolderList(params) {
  return request({
    url: '/appeditor/folder/list',
    method: 'get',
    params
  })
}

export function saveFolder(data) {
  return request({
    url: '/appeditor/folder/save',
    method: 'post',
    data
  })
}

export function removeFolder(ids) {
  return request({
    url: '/appeditor/folder/remove',
    method: 'post',
    data: ids
  })
}

